export class NotLoadedException extends Error {
    constructor(propertyName: string) {
        const message =
            `The property '${propertyName}' is not available. Before reading the property's value,` +
            `call the load method on the containing object and call "context.sync()" on the associated request context.`;

        super(message);
    }
}
